import { createRouter, createWebHistory } from "vue-router";
import { useAuthStore } from "@/stores/auth";
import Layout from "@/themes";
import Dashboard from "../pages/Dashboard.vue";
import NotFound from "../pages/NotFound.vue";
import { publicRoutes as userPublicRoutes, protectedRoutes as userProtectedRoutes } from "@/modules/Users/routes";
import { protectedRoutes as logsProtectedRoutes } from "@/modules/SystemLogs/routes";
import { protectedRoutes as settingsProtectedRoutes } from "@/modules/Settings/routes";
import { publicRoutes as authPublicRoutes } from "@/modules/Auth/routes";
import { protectedRoutes as genealogyProtectedRoutes } from "@/modules/Genealogy/routes";
import { protectedRoutes as auditProtectedRoutes } from "@/modules/Audit/routes";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/",
      component: Layout,
      children: [
        { path: "/", name: "dashboard", component: Dashboard },
        ...userProtectedRoutes,
        ...logsProtectedRoutes,
        ...settingsProtectedRoutes,
        ...genealogyProtectedRoutes,
        ...auditProtectedRoutes,
      ],
      meta: { requiresAuth: true },
    },
    ...userPublicRoutes,
    ...authPublicRoutes,
    { path: "/:pathMatch(.*)*", name: "not-found", component: NotFound },
  ],
});

router.beforeEach((to, from, next) => {
  const authStore = useAuthStore();
  if (to.meta.requiresAuth && !authStore.isAuthenticated) next({ name: "login" });
  else if (to.meta.requiresAdmin && authStore.user?.role !== "ADMIN") next({ name: "dashboard" });
  else if (to.meta.guestOnly && authStore.isAuthenticated) next({ name: "dashboard" });
  else next();
});

export default router;
